module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-6 col-lg-6"
  }, [_c('logo', {
    attrs: {
      "hideImage": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-0 col-sm-3 col-md-1 col-lg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "header__user-bar col-xs-12 col-sm-5 col-md-5 col-lg-5 end-xs"
  }, [_c('user-bar', {
    ref: "userBar",
    attrs: {
      "user": _vm.user
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row center-xs"
  }, [_c('aside', {
    staticClass: "col-xs-12 col-sm-4 col-md-3 col-lg-3"
  }, [_c('div', {
    staticClass: "box back-button"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'MapSelection'
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-android-arrow-back"
  }), _vm._v(" Map selection\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box add-button"
  }, [(_vm.user) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'DashboardAddDetails'
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-plus-round"
  }), _vm._v("\n            Add new\n          ")]) : _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.login($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-plus-round"
  }), _vm._v("\n            Login to add new\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box side-menu"
  }, [_c('div', [_c('b', [_vm._v("Type:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.handleTypeChange
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Any")]), _vm._v(" "), _vm._l((_vm.types), function(type) {
    return _c('option', {
      domProps: {
        "value": type.id
      }
    }, [_vm._v("\n                " + _vm._s(type.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Usage:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.handleUsageChange
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GENERAL"
    }
  }, [_vm._v("General")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OFFENSIVE"
    }
  }, [_vm._v("Offensive")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DEFENSIVE"
    }
  }, [_vm._v("Defensive")])])])])]), _vm._v(" "), _c('main', {
    staticClass: "map col-xs-12 col-sm-8 col-md-9 col-lg-9"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.map && _vm.minimap) ? _c('nade-map', {
    attrs: {
      "name": _vm.$route.params.map,
      "minimap": _vm.minimap,
      "entries": _vm.entries
    },
    on: {
      "open": _vm.handleMapOpen
    }
  }) : _c('div', {
    staticClass: "map__loader"
  }, [_c('loader')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "legend col-xs-12 col-sm-offset-4 col-sm-8 col-md-offset-3 col-md-9 col-lg-offset-3 col-lg-9"
  }, [_c('div', {
    staticClass: "box"
  }, _vm._l((_vm.types), function(type) {
    return _c('div', {
      staticClass: "legend__item"
    }, [_c('div', {
      staticClass: "legend__circle",
      style: (("background-color: " + (type.color)))
    }), _vm._v("\n            " + _vm._s(type.name) + "\n          ")])
  }))]), _vm._v(" "), (_vm.$route.name !== 'Dashboard') ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.$router.push({
          name: 'Dashboard'
        })
      }
    }
  }, [_c('router-view', {
    attrs: {
      "entries": _vm.entries,
      "map": _vm.map,
      "types": _vm.types,
      "minimap": _vm.minimap,
      "user": _vm.user
    }
  })], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('i', {
    staticClass: "ion-ios-help-outline"
  }), _vm._v(" Click on a line to see the details of the nade\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b60fe50e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/scenes/Dashboard/index.vue
// module id = 724
// module chunks = 1